var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"lg":12,"md":24}},[_c('div',{staticClass:"gb-l-container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }